import { render, staticRenderFns } from "./optionProducts.vue?vue&type=template&id=793b6dc9"
import script from "./optionProducts.vue?vue&type=script&lang=js"
export * from "./optionProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports